import { head, isNil, last, tail } from 'ramda';

export const joinURL = (...paths: (string | number | null | undefined)[]): string => {
  return paths.reduce<string>((acc, cur) => {
    if (isNil(cur) || cur === '') {
      return acc;
    }

    const curNormalized = String(cur);

    const accLast = last(acc);
    const curHead = head(curNormalized);

    // acc가 비어있으면 볼 필요가 없다
    if (!accLast) {
      return curNormalized;
    }
    // 슬래시가 겹치면 뒤쪽에서 제외하고 붙이기 (tail)
    if (accLast === '/' && curHead === '/') {
      return acc + tail(curNormalized);
    }
    // 양쪽 다 슬래시가 없으면 추가
    if (accLast !== '/' && curHead !== '/') {
      return `${acc}/${cur}`;
    }
    // 한 쪽에만 있으면 바로 합치기
    return acc + cur;
  }, '');
};
